import { styled, Switch, SwitchProps } from "@mui/material"

export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
  width: 38,
  height: 22,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 5,
    transition: "all 0.3s",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      transition: "all 0.3s",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--Schemes-Primary)",
        opacity: 1,
        border: "none",
      },
      '& .MuiSwitch-thumb': {
        color: "var(--Schemes-On-Primary)",
        width: 16,
        height: 16,
        marginTop: "-2px",
        marginLeft: "-2px",
      },
      '&:hover': {
        '& .MuiSwitch-thumb': {
          color: "var(--Schemes-On-Primary)",
        }
      }
    },
    "&:hover": {
      "& .MuiSwitch-thumb": {
        color: "var(--Schemes-Primary)",
      },
      "& + .MuiSwitch-track": {
        border: "solid 2px var(--Schemes-Primary)",
      }
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 12,
    height: 12,
    color: "var(--Schemes-On-Surface)",
    transition: "all 0.3s",
  },
  "& .MuiSwitch-track": {
    borderRadius: 24 / 2,
    backgroundColor: "var(--Schemes-Surface-Container-High)",
    border: "solid 2px var(--Schemes-On-Surface)",
    opacity: 0.8,
    transition: "all 0.3s",
  },
}))
